import { render, staticRenderFns } from "./FormAddEditBlock.vue?vue&type=template&id=48cf8232&"
import script from "./FormAddEditBlock.vue?vue&type=script&lang=ts&"
export * from "./FormAddEditBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports